/* eslint-disable @typescript-eslint/no-explicit-any */
import { useAuth } from "@/context/AuthProvider";
import { api } from "@/services/api";
import { LogOut, Mail, Phone, Play, Trash2, User, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function PerfilPage() {
  const { user, logout, showOnboarding } = useAuth();
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);

  const confirmarExclusao = () => {
    if (
      window.confirm(
        "Tem certeza que deseja excluir sua conta? Esta ação não pode ser desfeita."
      )
    ) {
      handleExcluirConta();
    }
  };

  const handleExcluirConta = async () => {
    try {
      setIsDeleting(true);
      await api.delete("/tutores/excluir");

      alert(
        "Conta excluída com sucesso. Agradecemos por usar nosso aplicativo. Mandaremos um e-mail para você com mais informações em até 7 dias úteis."
      );
      logout();
    } catch (error: any) {
      alert(error?.response?.data?.error || "Erro ao excluir conta");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-end">

        <button
          onClick={() => navigate(-1)}
          className="p-2 rounded-full hover:bg-gray-100 transition-colors"
        >
          <X size={20} className="text-gray-600" />
        </button>
      </div>

      {/* Informações do usuário */}
      <div className="text-center mb-8">
        <div className="w-24 h-24 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <span className="text-white text-3xl font-bold">
            {user?.nome?.charAt(0).toUpperCase() || "HMV"}
          </span>
        </div>
        <h2 className="text-xl font-bold text-gray-800 capitalize">
          {user?.nome}
        </h2>
        <p className="text-gray-500 mt-1">{user?.email}</p>
      </div>

      {/* Card de informações pessoais */}
      <div className="bg-white rounded-2xl p-6 shadow-sm border border-gray-200">
        <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center">
          <User size={20} className="mr-2 text-gray-600" />
          Informações pessoais
        </h3>

        <div className="space-y-4">
          <div className="border-b border-gray-200 pb-3">
            <div className="flex items-center mb-1">
              <Mail size={16} className="text-gray-500 mr-2" />
              <span className="text-gray-500 text-sm">Email</span>
            </div>
            <p className="text-gray-800 font-medium">{user?.email}</p>
          </div>

          <div className="pb-3">
            <div className="flex items-center mb-1">
              <Phone size={16} className="text-gray-500 mr-2" />
              <span className="text-gray-500 text-sm">Telefone</span>
            </div>

            <p className="text-gray-800 font-medium">
              {user?.telefone || "Não informado"}
            </p>
          </div>
        </div>

       
      </div>

      {/* Tutorial */}
      <div className="flex items-center justify-center">
      <button
          onClick={showOnboarding}
          className="flex items-center justify-center gap-2 "
        >
          <Play size={20} className="text-black mr-2" />
          <span className="text-black font-semibold">
            Ver tutorial novamente
          </span>
        </button>
        </div>
      {/* Botões de ação */}
      <div className="grid grid-cols-2 sm:grid-cols-2 gap-4">
        <button
          onClick={confirmarExclusao}
          disabled={isDeleting}
          className="bg-white border border-red-500 rounded-xl h-16 flex items-center justify-center transition-all duration-200 hover:bg-red-50 disabled:opacity-50"
        >
          <Trash2 size={22} className="text-red-500 mr-2" />
          <span className="text-red-500 font-bold">
            {isDeleting ? "Excluindo..." : "Excluir conta"}
          </span>
        </button>

        <button
          onClick={logout}
          className="bg-blue-600 rounded-xl h-16 flex items-center justify-center transition-all duration-200 hover:bg-blue-700"
        >
          <LogOut size={22} className="text-white mr-2" />
          <span className="text-white font-bold">Sair da conta</span>
        </button>
      </div>
    </div>
  );
}
